{
  "code": "EX-00",
  "MESSAGE": {
    "NO_INTERNET": "No detectamos una conexión estable a internet, por favor inténtalo más tarde.",
    "NO_INTERNET_ITEMS": "No pudimos traer los valores 'online', por lo que trabajarás con valores generales estándares de los ítems.",

    "200_PREFIX": "<span class=\"font-bold\">Muy bien!</span><br>",
    "200_REFRESHED": "Los catálogos generales de tu perfil de han actualizado satisfactoriamente.",
    "200_MAP_PLANNING": "Tu planificación de visita ha sido registrada.",
    "200_STAKEHOLDER": "Se actualizó la información del cliente.",
    "200_APPOINTMENT": "Tu visita # {{appointmentId}} fue registrada.",
    "200_APPOINTMENT_ANALYTICS": "Visita registrada.",
    "200_APPOINTMENTS_OFFLINE": "Tus visitas se sincronizaron.",
    "200_ORDER": "Tu pedido # {{orderId}} fue registrado.",
    "200_PRE_ORDER": "El pedido actual se ha creado automáticamente basado en el método {{catalogType}}.",
    "200_ORDER_ANALYTICS": "Pedido registrado.",
    "200_ORDERS_OFFLINE": "Tus pedidos se sincronizaron.",
    "200_CUSTOMER": "El cliente fue registrado.",
    "200_CUSTOMER_ANALYTICS": "Cliente registrado.",
    "200_CUSTOMER_CONTACT": "El contacto del cliente se ha guardado satisfactoriamente.",
    "200_NOTIFICATION_DELETED": "Tu notificación se marcó como eliminada.",
    "200_NOTIFICATION_DELETED_FULL": "Tu notificación se eliminó por completo.",
    "200_USER_PASSWORD_RESET": "Tu contraseña se restableció satisfactoriamente.",
    "200_USER_REGISTER": "Tu usuario ha sido creado satisfactoriamente. Tu cuenta será validada y posteriormente activada. Comunícate con tu supervisor para conocer el estado de activación.",
    "200_SYNC_WHO_AM_I": "Tu información se encuentran sincronizada en P360° Mobile",
    "200_SYNC_GEN_0001": "Tu fichero se encuentran sincronizado en P360° Mobile",
    "200_SYNC_GEN_0002": "Tus productos se encuentran sincronizados en P360° Mobile",
    "200_SYNC_GEN_0019": "Tus filtros de búsqueda se encuentran sincronizados en P360° Mobile",
    "200_SYNC_GEN_0040": "Se han sincronizado en P360° Mobile las campañas de tu parrilla promocional.",
    "200_CUSTOMERS_OFFLINE": "Tus clientes se sincronizaron.",
    "200_CAMPAIGN_SAVE_NEW": "Tu parrilla promocional fue creada.",
    "200_CAMPAIGN_SAVE": "Tu parrilla promocional fue actualizada.",
    "200_CAMPAIGN_RELATIONSHIP": "Se han otorgado satisfactoriamente los permisos de acceso a la parrilla.",
    "200_CAMPAIGN_SEND_EMAIL": "La campaña <b>{{campaignName}}</b> está en proceso para ser enviada por correo electrónico.",
    "200_APPOINTMENT_SMART_SAMPLE": "El levantamiento de muestras se ha creado automáticamente basado en el método {{catalogType}}.",
    "200_APPOINTMENT_SMART_STOCK": "El levantamiento de stockpedido se ha creado automáticamente basado en el método {{catalogType}}.",
    "200_DYNAMIC_FORM_ANSWER": "Tu encuesta con id #{{id}} fue registrada.",
    "200_CAMPAIGN_THERAPEUTIC_SPECIALTIES": "Las especialidades terapeuticas se asignaron a tu parrilla promocional",
    "200_RD_0050": "Tu solicitud de alta de fichero fue registrada.",
    "200_ROUTE": "Tu ubicación PDC fue enviada.",

    "204_PREFIX": "<span class=\"font-bold\">Lo sentimos!</span><br>",
    "204_PREFIX_ALT": "<span class=\"font-bold\">Te informamos!</span><br>",
    "@204_PRE_ORDER": "No hemos encontrado información para tu pedido automático.",
    "@204_PRE_ORDER_BY_ID": "No hemos encontrado el pedido # {{orderId}} que ingresaste.",
    "204_ACTIVE_CAMPAIGNS": "Aún no existe ninguna parrilla promocional activa creada.",
    "204_APPOINTMENTS_OFFLINE": "No se han podido sincronizar tus visitas.",
    "204_CAMPAIGN_SAVE": "No se pudo guardar la información de tu parrilla promocional.",
    "204_CAMPAIGN_VIEW_BY_ID": "No existe la parrilla promocional con el id indicado.",
    "204_CUSTOMERS_OFFLINE": "No se han podido sincronizar tus clientes.",
    "204_ORDERS_OFFLINE": "No se han podido sincronizar tus pedidos.",

    "@204_FROM_SPS": "",
    "204_GENERIC": "No se pudo obtener información en tu consulta actual.",
    "204_APPOINTMENT_HISTORY": "No pudimos encontrar la información del histórico de visitas para este cliente.",
    "204_AUDIT_CUBE_RX": "No pudimos encontrar información de auditoría de prescripciones (RX).",
    "204_AUDIT_CUBE_MD": "No pudimos encontrar información de auditoría de mercado de ventas.",
    "204_COMPANY_PLANNING_HISTORY": "No se te ha asignado un fichero de visitas.",
    "204_MAP_PLANNING_HISTORY": "No pudimos encontrar visitas planificadas para la fecha o rango de fechas seleccionadas.",
    "204_MARKET_SHARE": "No pudimos encontrar información de análisis de mercado de ventas.",
    "204_ORDER_HISTORY": "No pudimos encontrar la información del histórico de pedidos para este cliente.",
    "204_PRE_ORDER": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "204_PRE_ORDER_BY_ID": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "204_SALESFORCE_TREE": "No pudimos encontrar la información de los representantes. Por favor sincroniza tu APP.",
    "204_ITEM_SMART_STOCK": "No se recuperó ningun ítem para este método en este canal.",
    "204_ITEM_SMART_SAMPLE": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "204_ITEM_SMART_SAMPLE_BY_ID": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "204_RD_0049": "¡No existen contactos georeferenciados en esta área!",
    "204_GEN_0000": "No se pudo obtener la información de los catálogos. Por favor sincroniza tu APP.",
    "204_GEN_0001": "No se pudo obtener la información de los clientes. Por favor sincroniza tu APP.",
    "204_GEN_0002": "No se pudo obtener la información de los ítems. Por favor sincroniza tu APP.",
    "204_GEN_0003": "No se pudo obtener la información completa del cliente. Por favor verifica con tu supervisor que el cliente se encuentre asignado.",
    "204_GEN_0004": "No se pudo obtener tu información personal. Por favor verifica tu usuario con tu supervisor o el administrador del sistema.",
    "204_GEN_0019": "No se pudo obtener la información de los clientes. Por favor sincroniza tu APP.",
    "204_GEN_0021": "No se pudo obtener la información de las líneas. Por favor sincroniza tu APP.",
    "204_GEN_0022": "No se pudo obtener la información de los segmentos competitivos. Por favor sincroniza tu APP.",
    "204_GEN_0026": "No pudimos encontrar información de concentración para el filtro seleccionado.",
    "204_GEN_0027": "No se pudo obtener la información de ayuda.",
    "204_GEN_0030": "No se pudo obtener la información de los despachadores. Por favor sincroniza tu APP.",
    "204_GEN_0032": "___ACCIONES COMERCIALES___",
    "204_GEN_0033": "___OPCIONES DE MENU___",
    "204_GEN_0036": "No se pudo obtener las opciones disponibles para visualizar tus dashboards.",
    "204_GEN_0037": "Aún no se han cargado tus KPIs en la plataforma.",
    "204_GEN_0038": "En esta visita no se entregó muestras ni material promocional.",
    "204_GEN_0040": "No tienes ninguna parrilla promocional asociada.",
    "204_GEN_0041": "No pudimos sincronizar el catálogo de redes sociales, inténtalo más tarde.",
    "204_GEN_0046_C": "Este cliene aún no tiene registrados stakholders.",
    "204_GEN_0046_F": "Esta farmacia aún no tiene registrados stakholders.",
    "204_RX_0001": "No pudimos encontrar información de prescripciones para los segmentos competitivos.",
    "204_RX_0002": "No pudimos encontrar información de prescripciones por segmento competitivo.",
    "204_RX_0003": "No pudimos encontrar información de prescriptores por segmento competitivo y producto seleccionados.",
    "204_RX_0024": "No pudimos encontrar información de análisis de prescripciones.",
    "204_RX_0035": "No pudimos encontrar información de análisis de prescripciones.",
    "204_RX_0047": "Este médico no tiene prescripciones captadas.",
    "204_RX_0048": "No se encontraron indicadores prescriptivos para este médico.",
    "204_SELLIN_0001": "No pudimos encontrar un cumplimiento de ventas para el producto seleccionado.",
    "204_SELLIN_0002": "No pudimos encontrar información de ventas para el filtro seleccionado.",
    "204_SELLIN_0006": "No pudimos encontrar información de ventas para el filtro seleccionado.",
    "204_SELLIN_0008": "No pudimos encontrar información de ventas de tus productos.",
    "204_SELLIN_0009": "No pudimos encontrar información de ventas para el filtro seleccionado.",
    "204_SELLIN_0010": "No pudimos encontrar información de ventas por línea.",
    "204_SELLIN_0011": "No pudimos encontrar información de ventas por producto.",
    "204_SELLIN_0012": "No pudimos encontrar información de ventas por ítem.",
    "204_SELLIN_0013": "No pudimos encontrar información de ventas por cliente (top 10).",
    "204_SELLIN_0017": "No pudimos encontrar información de cumplimiento de ventas mensualizado.",
    "204_SELLIN_0018": "No pudimos encontrar información de ventas para la perspectiva seleccionada.",
    "204_SELLIN_0020": "No pudimos encontrar información de KPI´s de líneas.",
    "204_SELLIN_0028": "No pudimos encontrar información del performance interactivo",
    "204_SELLIN_0029": "___INFORMACIÓN GRÁFICO Z___",
    "204_SELLIN_0034": "No pudimos encontrar información de ventas para el filtro seleccionado.",

    "@OTHER_ERRORS_FROM_SPS": "",
    "401_BAD_CREDENTIALS": "El usuario y/o contraseña que ingresaste no son válidos.",
    "401_LOCKED_ACCOUNT": "Tu usuario se encuentra bloqueado. Comunícate con el administrador del sistema.",
    "401_ACCOUNT_DISABLED": "Tu usuario se encuentra desactivado. Comunícate con el admministrador del sistema.",
    "401_UNKNOWN": "No se pudo completar tu inicio de sesión. Por favor inténtalo nuevamente.",
    "404_PREFIX": "",
    "404_APPOINTMENT": "Tu visita no se pudo grabar. Queda pendiente para sincronización.",
    "404_ORDER": "Tu pedido no se pudo grabar. Queda pendiente para sincronización.",
    "404_CUSTOMER": "No se puede guardar la información que ingresaste para este cliente. Inténtalo más tarde.",
    "404_CUSTOMER_ANALYTICS": "Cliente no registrado.",
    "408_GENERIC": "Tuvimos problemas para conectarnos con P360°, por favor inténtalo nuevamente.",
    "500_APPOINTMENT_ANALYTICS": "Visita no registrada.",
    "500_APPOINTMENT_OFFLINE": "Tu visita para <span class=\"font-bold\">{{customer}}</span> no se pudo sincronizar.",
    "500_GENERIC": "Tuvimos un problema para conectarnos con P360°, por favor contacta a tu administrador.",
    "500_NEW_CUSTOMER": "Estas intentando realizar el registro de tu acción comercial con un cliente recién creado. Solicita su activación y asignación antes de proceder.",
    "500_CUSTOMER_NOT_ASSIGNED": "El cliente que seleccionaste no te ha sido asignado en tu fichero vigente.",
    "500_CLIENT_ALREADY_EXIST": "El cliente que estás intentando registrar ya existe.",
    "500_GPS": "No se pudo reconocer tu posición actual. Asegúrate de tener activado el GPS de tu dispositivo.",
    "500_ORDER_OFFLINE": "Tu pedido para <span class=\"font-bold\">{{customer}}</span> no se pudo sincronizar.",
    "500_PRE_ORDER": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "@500_PRE_ORDER": "No pudimos cargar tu pedido automático.",
    "500_USER_PASSWORD_RESET": "No pudimos restaurar tu contraseña, verifica que hayas ingresado correctamente tu correo electrónico.",
    "500_USER_REGISTER": "No pudimos crear tu usuario, por favor inténtalo nuevamente o comunícate con el administrador del sistema.",
    "500_CUSTOMER_OFFLINE": "Tu cliente <span class=\"font-bold\">{{customer}}</span> no se pudo sincronizar.",
    "500_UPDATE_PUBLISHED_CAMPAIGN": "No pudimos actualizar tu parrilla promocional ya que no permite cambios actualmente.",
    "500_APPOINTMENT_HISTORY_PREV": "No es posible realizar planificaciones en pasado.",
    "500_APPOINTMENT_SMART_SAMPLE": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "500_APPOINTMENT_SMART_STOCK": "El método {{catalogType}}, no ha retornado ningún ítem.",
    "AUTOMATIC_ADDRESS": " Nosotros nos encargamos de poner la dirección de tu cliente en base a la ubicación en tiempo real.",
    "WITH_NEW_CUSTOMER": "El cliente que seleccionaste aún no te ha sido asignado, por lo que tu acción comercial se generará en modo offline. Solicita su activación y asignación antes de sincronizarlo.",
    "WITH_NEW_CUSTOMER_OFFLINE": "El cliente de tu acción comercial aún no se ha activado por parte del administrador por lo cual no se sincronizará.",
    "WITH_NOT_SYNCED_CUSTOMER_OFFLINE": "El cliente con el que deseas ejecutar tu acción comercial aún no te ha sido asignado por lo cual no se sincronizará. Solicita su activación y asignación antes de sincronizarlo.",
    "NEW_APPOINTMENT_MESSAGE": "¡Recuerda que puedes volver a registrar visitas, seleccionando un nuevo cliente!",
    "NEW_ORDER_MESSAGE": "¡Recuerda que puedes volver a registrar pedidos, seleccionando un nuevo cliente!",
    "GENERIC_EMPTY_MESSAGE": "Lo sentimos,</br>no existe información a mostrar.",

    "ADMIN_CAMPAIGN_PUBLISH_SUCCESS_MESSAGE": "Tu parrilla promocional ahora se encuentra publicada en P360° Mobile.",
    "ADMIN_CAMPAIGN_PUBLISH_ERROR_MESSAGE": "No pudimos publicar tu parrilla promocional, inténtalo nuevamente o comunícate con el administrador del sistema.",
    "ADMIN_CAMPAIGN_DEACTIVATE_SUCCESS_MESSAGE": "Tu parrilla promocional ahora se encuentra desactivada en P360° Mobile.",
    "ADMIN_CAMPAIGN_DEACTIVATE_ERROR_MESSAGE": "No pudimos desactivar tu parrilla promocional, inténtalo nuevamente o comunícate con el administrador del sistema."
  },

  "FORM_VALIDATORS": {
    "USERNAME_REQUIRED": "Debes ingresar tu usuario",
    "PASSWORD_REQUIRED": "Debes ingresar tu contraseña",
    "CODE": "Debes ingresar el código.",
    "ADDRESS": "Debes ingresar la dirección.",
    "CATEGORY": "Debes seleccionar una categoría.",
    "CLI_DISTRIB_CODE": "Debes ingresar el código.",
    "CUSTOMER_NUMBER": "Debes ingresar el número fiscal.",
    "EMAIL_REQUIRED": "Debes ingresar un correo.",
    "EMAIL_INVALID": "Debes ingresar un correo válido.",
    "EMAIL_INVALID_FOR": "Debes ingresar un correo válido para el campo {{value}}.",
    "GLOBAL_GROUP": "Debes seleccionar un grupo de cadena.",
    "GROUP": "Debes seleccionar un grupo.",
    "LOCATION": "Debes seleccionar una población.",
    "NAME": "Debes ingresar el nombre.",
    "DOCUMENT_REQUIRED": "Debes subir un documento PDF y seleccionar al menos 1 página.",
    "PRODUCTS_REQUIRED": "Debes seleccionar al menos un producto.",
    "SPECIALTIES_REQUIRED": "Debes seleccionar al menos una especialidad.",
    "CLIENTS_REQUIRED": "Debes seleccionar al menos un Médico/PVC, recuerda que tienes la opción de \"todos\".",
    "COLLABORATORS_REQUIRED": "Debes seleccionar al menos un colaborador, recuerda que tienes la opción de \"todos\".",
    "COMPANY": "Debes ingresar la compañía."
  },

  "CONFIRMATION_DIALOG": {
    "TITLE": "¿Estás seguro de {{screen}}?{{additional}}",
    "ALL_PRODUCTS": "realizar la consulta de 'TODOS LOS PRODUCTOS', puede tomar mucho tiempo dependiendo de tu conexión a internet (podrías además consultar seleccionando un producto específico)",
    "NEW_CUSTOMER": "registrar el nuevo cliente",
    "LEAVE_FORM_CUSTOMER": "salir del registro de cliente",
    "LEAVE_FORM_CUSTOMER_ADDITIONAL": " Perderás toda la información que has registrado hasta el momento",
    "REMOVE_ITEM": "eliminar el ítem",
    "APPOINTMENT": "registrar tu visita",
    "APPOINTMENT_DELETE": "eliminar tu visita pendiente de sincronización",
    "APPOINTMENTS": "registrar tus visitas",
    "LEAVE_FORM_APPOINTMENT": "salir del registro de visita",
    "LEAVE_FORM_APPOINTMENT_ADDITIONAL": " Si no reportas la visita esta se anulará!",
    "ORDER": "registrar su pedido",
    "ORDER_DELETE": "eliminar tu pedido pendiente de sincronización",
    "ORDERS": "registrar sus pedidos",
    "OFFLINE_ADDITIONAL": " Esto puede tomar un poco de tiempo, asegúrate de tener una conexión a internet estable.",
    "LEAVE_FORM_ORDER": "salir del registro de pedido",
    "LEAVE_FORM_ORDER_ADDITIONAL": " Si no reportas el pedido esta se anulará!",
    "LOGIN_DIFFERENT_ACCOUNT": "iniciar sesión con otro usuario",
    "LOGIN_DIFFERENT_ACCOUNT_ADDITIONAL": " Esta acción limpiará toda la información registrada en la aplicación.",
    "CUSTOMERS": "registrar sus clientes",
    "CUSTOMER_DELETE": "eliminar tu cliente pendiente de sincronización",

    "CAMPAIGN_PUBLISH": "publicar esta parrilla promocional",
    "CAMPAIGN_DEACTIVATE": "desactivar esta parrilla promocional",
    "CAMPAIGN_NEW_QUESTION": "Vas a crear la campaña de la parrilla promocional.</br><span class='text-sm'>Se generará la previsualización de tu campaña, puede tomar unos minutos.</span></br></br>¿Estás seguro de continuar?",
    "CAMPAIGN_EDIT_QUESTION": "Estas actualizando tu parrilla promocional. Toma en cuenta que esta acción puede sobreescribir la prioridad de otras previamente creadas.</br></br>¿Estás seguro de continuar?",
    "CAMPAIGN_UPDATE_QUESTION": "Estas actualizando tu parrilla promocional.<br>Toma en cuenta que solo se puede actualizar la asociación de productos, especialidades, médicos/PVC y colaboradores.</br></br>¿Estás seguro de continuar?",

    "DYNAMIC_FORM_DISCARD_ANSWERS": "descartar tu encuesta",
    "DYNAMIC_FORM_SAVE_ANSWERS": "registrar tu encuesta",

    "DYNAMIC_FORM_PUBLISH": "publicar este formulario",
    "DYNAMIC_FORM_DEACTIVATE": "desactivar este formulario",
    "DYNAMIC_FORM_NEW_QUESTION": "Vas a crear el formulario.</br></br>¿Estás seguro de continuar?",
    "DYNAMIC_FORM_EDIT_QUESTION": "Estas actualizando tu formulario.</br></br>¿Estás seguro de continuar?"
  },

  "MESSAGES": {
    "EX-01": "El pedido número number se realizó exitosamente.",
    "EX-02": "La visita número number se realizó exitosamente.",
    "ER-01": "Ya existe un registro con los datos principales.",
    "ER-02": "No existe el registro.",
    "ER-03": "No existen registros.",
    "ER-04": "No se pudo ingresar el pedido.",
    "ER-05": "No se pudo ingresar la visita.",
    "ER-06": "Este código de cliente ya se encuentra registrado.",
    "EX-SAVE-APPOINTMENT-OFF": "Tus visitas se sincronizaron.",
    "EX-SAVE-ORDER-OFF": "Tus pedidos se sincronizaron.",
    "CONFIRMATION": "¿Está seguro de {{screen}}?{{additional}}",
    "CONFIRMATION_ALL_PRODUCTS": "realizar la consulta de 'TODOS LOS PRODUCTOS', puede tomar mucho tiempo dependiendo de su conexión a internet (le aconsejamos hacer una consulta seleccionando un producto específico)",
    "CONFIRMATION_STAKEHOLDER": "registrar información del cliente",
    "CONFIRMATION_REMOVE_APPOINTMENT": "eliminar la visita",
    "CONFIRMATION_REMOVE_ORDER": "eliminar el pedido",
    "RESET_APP": "reiniciar la aplicación",
    "REQUIRED_ITEM": "Debes seleccionar un ítem",
    "REQUIRED_QUANTITY": "Debes ingresar la cantidad",
    "DUPLICATED_ITEM": "El ítem ya se encuentra seleccionado",
    "REQUIRED_REFERENCE": "Debe ingresar la referencia",
    "REQUIRED_CLIENT": "Debes seleccionar un cliente",
    "REQUIRED_CONTACT_NAME": "El nombre del contacto es requerido",
    "REQUIRED_NEXT_DATE_APPOINTMENT": "La fecha de la próxima visita es requerida",
    "MAX_400_LENGTH": "Debe escribir máximo 400 caracteres",
    "REQUIRED_DEPENDENTS": "El número de dependientes es requerido",
    "REQUIRED_SHOULD_COMPLETE_APPOINTMENT_SAMPLE": "Recuerda complementar la información de levanamiento de muestras",
    "REQUIRED_SHOULD_COMPLETE_APPOINTMENT_STOCK": "Recuerda complementar la información de levanamiento de stock",
    "REQUIRED_COMPLETE_APPOINTMENT_STOCK": "Tienes que complementar la información de levanamiento de stock",
    "REQUIRED_DEPENDENT_NAME": "El nombre de dependiente es requerido",
    "MIN_QUANTITY": "La cantidad debe ser mayor a 0",
    "REQUIRED_DISPATCHER": "El despachador es requerido",
    "REQUIRED_DELIVERY_DATE": "La fecha de entrega es requerida",
    "REQUIRED_PAYMENT_DATE": "La fecha de pago es requerida",
    "MIN_1_ITEM": "Tiene que ingresar al menos un ítem con una cantidad diferente de 0",
    "REQUIRED_DOCUMENT": "El documento de identidad es requerido",
    "FAILURE_PHOTO": "No se pudo completar el envío de la evidencia",
    "FAILURE_STOCK": "No se pudo completar el envío de registro de stock",
    "FAILURE_FACE": "No se pudo completar el envío de registro de caras",
    "FAILURE_TRAINING": "No se pudo completar el envío de registro de capacitación",
    "FAILURE_DISPLAY": "No se pudo completar el envío de registro de exhibición",
    "REQUIRED_PHONE": "El teléfono es requerido",
    "REQUIRED_FULLNAME": "El nombre completo es requerido",
    "REQUIRED_EMAIL": "El correo electrónico es requerido",
    "NO_MORE_DRILLDOWN": "No es posible hacer DrillDown porque está en el último nivel de la jerarquía, utilice el ícono para regresar al nivel superior.",
    "APPOINTMENT": {
      "REQUIRED_QTY": "Debes ingresar la mínima reposición",
      "REAL_QTY": "Debes ingresar el real encontrado",
      "NEWS": "Debes seleccionar la novedad del stock",
      "ACTION": "Debes seleccionar la acción del punto de venta",
      "CURRENT_FACE": "Debes ingresar la cantidad de caras planogramas",
      "WIN_FACE": "Debes ingresar la cantidad de caras ganadas",
      "LOCATION_FACE": "Debes ingresar la ubicación de las caras",
      "TRAINING_HIT": "Debes seleccionar el tipo de capacitación",
      "TRAINING_MATERIAL": "Debes seleccionar el material de capacitación",
      "DISPLAY_ID": "Debes seleccionar el tipo de exhibición",
      "DISPLAY_WIN": "Debes ingresar la cantidad de exhibiciones ganadas",
      "DISPLAY_LOCATION": "Debes ingresar la ubicación de las exhibiciones",
      "TRAINING_PEOPLE": "Debes seleccionar al menos un contacto",
      "ACTIVE_APPOINTMENT_FORM": "Asegúrate de agregar la información registrada para la sección \"{{section}}\"."
    },
    "LEAVE_FORM_CLIENT": "salir del registro de cliente",
    "LEAVE_FORM_CLIENT_ADDITIONAL": "",
    "CRM_NO_APPOINTMENTS": "No tienes visitas planificadas para el día de hoy"
  }
}
